import {Injectable} from '@angular/core';
import {Country} from "../../../models/referential/country.model";
import {ParametersDatabase} from "../../databases/parameters.database";

@Injectable({
    providedIn: 'root'
})
export class SqliteCountryRepository {

    constructor(private readonly parametersDatabase: ParametersDatabase) {}

    async getCountryByIsoCode(isoCode: string): Promise<Country> {
        const countries: Country[] = await this.parametersDatabase.queryObjects<Country>(
            `SELECT *
         FROM country
         WHERE isoCode = '${isoCode.toUpperCase()}'`,
            null,
            []
        );

        return this.mapCountry(countries[0]);
    }

    private mapCountry(country: Country): Country {
        if (!country) return null;

        return {
            ...country,
            hasCrm: Boolean(Number(country.hasCrm))
        };
    }
}
